export default __webpack_public_path__ + "static/media/MapFullImage.c1eeeb5e.png";